import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import CoreMixin from '@nodes/mixins/Core';
import { v4 as uuid } from 'uuid';
import { digits } from '@nodes/helpers/number';
import Props from './props';

@Component({
    components: {},
})

/**
 * @name ProductsRate
 */
export default class ProductsRate extends Mixins(HybridMixin, Props, CoreMixin) {
    digits = digits;

    /**
     * @returns {Array}
     */
    userStarts: Array<any> = [];

    /**
     * @inheritdoc
     */
    created() {
        /**
         * Create user vote array based on rate gutter
         */
        this.userStarts = [];
        if (this.getValue('userRate')) {
            this.userStarts = this.makeStarsArray(this.getValue('userRate'));
        } else {
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < this.getValue('rateGutter'); index++) {
                this.userStarts.push({ id: uuid(), value: 0 });
            }
        }
    }

    /**
     * Show user rate when mouse leave stars
     * 
     * @param {number} i index of star that was mouse hover
     */
    enterIndex(i: number) {
        this.userStarts = this.userStarts.map((item, index) => {
            if (index > i) {
                return {
                    id   : item.id,
                    value: 0,
                };
            }
            return {
                id   : item.id,
                value: 1,
            };
        });
    }

    /**
     * Show user rate when mouse leave stars
     * 
     * @param {number} i index of star that was mouse hover
     */
    leaveIndex(i: number) {
        if (this.getValue('userRate')) {
            this.userStarts = this.makeStarsArray(this.getValue('userRate'));
        } else {
            this.userStarts = this.userStarts.map((item, index) => {
                if (index > i) {
                    return item;
                }
                return {
                    id   : item.id,
                    value: 0,
                };
            });
        }
    }

    /**
     * Show user rate when mouse leave stars
     * 
     * @param {number} i index of star that was mouse hover
     */
    saveUserVote(i: number) {
        if (!!parseInt(this.getValue('rateConfig').usersOnly, 10) && !this.$store.getters['auth/isLoggedIn']) {
            this.$toast.error(this.$t('products-rate.login'));
        } else {
            this.$wait.start('user-vote-save');
            this.$services.Rate.save({
                value: i + 1,
                id   : this.getValue('postId'),
                model: 'content-post',
            }).then(() => {
                this.$toast.success(this.$t('products-rate.success'));
            }).catch((error) => {
                if (error.response.data.errorCode === 403) {
                    this.$toast.error(this.$t('products-rate.login'));
                }
                this.handleError(error);
            }).finally(() => {
                this.$wait.end('user-vote-save');
            });
        }
    }

    /**
     * make an array for show stars state
     *
     * @param {number} value - slug of value that you want to apply on start
     * @returns {Array}
     */
    makeStarsArray(value: number): Array<any> {
        // eslint-disable-next-line no-param-reassign
        const array = [];
        const empty: any = Math.floor(this.getValue('rateGutter') - value);
        const [full, half] = String(value).split('.');
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < parseInt(full, 10); index++) {
            array.push({
                id   : uuid(),
                value: 1,
            });
        }
        if (half) {
            array.push({
                id   : uuid(),
                value: 0.5,
            });
        }
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < empty; index++) {
            array.push({
                id   : uuid(),
                value: 0,
            });
        }

        return array;
    }
}
